var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("global-dropdown", {
    attrs: {
      options: _vm.filter.options,
      "initial-title": _vm.filter.title,
      disabled: _vm.filterDisabled(_vm.filter.options),
      "multi-select": true,
      theme: _vm.theme,
    },
    on: { change: _vm.onSelectionChange },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }